import { render, staticRenderFns } from "./MyWellbeingCheckLaunchFaqs.vue?vue&type=template&id=07c887ca&scoped=true&"
import script from "./MyWellbeingCheckLaunchFaqs.vue?vue&type=script&lang=js&"
export * from "./MyWellbeingCheckLaunchFaqs.vue?vue&type=script&lang=js&"
import style0 from "./MyWellbeingCheckLaunchFaqs.vue?vue&type=style&index=0&id=07c887ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c887ca",
  null
  
)

export default component.exports